import React from 'react';
import { useOutsideClick } from 'hooks/useOutsideClick';
import { TStickyPosition } from 'types/utils';
import { useSticky } from 'hooks/useSticky';

import { createPopupClassName } from './popupStyles';

type Props = {
  testId?: string;
  onOutsideClick?(): void;
};

export const PopupComponent: React.FC<Props> = (props) => {
  const { children, onOutsideClick, testId } = props;

  const wrapperRef = React.useRef<HTMLDivElement>(null);
  const outsideClickRef = useOutsideClick<HTMLDivElement>(onOutsideClick);

  const [sticky, setSticky] = React.useState<null | TStickyPosition>(null);

  const onStick = setSticky;

  useSticky(wrapperRef, { onStick });

  const wrapperClassName = createPopupClassName('wrapper');

  const windowClassName = createPopupClassName('window', {
    sticky: sticky === null ? undefined : sticky,
  });

  return (
    <div ref={wrapperRef} className={wrapperClassName}>
      <div
        ref={outsideClickRef}
        className={windowClassName}
        data-testid={testId}
      >
        {children}
      </div>
    </div>
  );
};
